import { type ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { GoToSettings } from './GoToSettings'

export const GoToSpecificSettings = (): ClickNavigationSection[] => {
  return [
    {
      id: 'settings',
      label: 'GoTo Connect Settings',
      content: () => <GoToSettings />,
    },
  ]
}
